let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("6hk90"), load("Sa6Gm"), load("auDuq")]).then(() => parcelRequire('3U5pN'));